import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import FormSingleSelect, { SelectItem } from 'src/components/Control/FormControls/FormSingleSelect';
import { ErrorBag } from 'src/models/ErrorModel';
import { FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FORM_ID } from 'src/models/FormModel';
import { FundraisingLanguages, FundraisingLanguagesList } from 'src/constants/FundraisingLanguages';
import { t } from 'src/lib/language';
import { CSSProperties } from 'react';

const useStyles = makeStyles(() => ({
  formControl: {
    width: '100%',
    marginTop: 0,
    marginBottom: '8px',
  },
}));

interface Props {
  disabled?: boolean,
  form: FORM_ID,
  name: string,
  onChange: (value:FundraisingLanguages, field: string) => void,
  value?: string,
  label?: string,
  styles?: CSSProperties,
  values?: FundraisingLanguages[],
}

const FundraisingLanguageSelector = (props: Props) => {
  const classes = useStyles();

  const lang = useSelector((state: Store) => state.language.language);

  const {
    disabled, form, name, onChange, value, label, styles, values,
  } = props;

  const languages = {
    en: t(lang, 'forms.fundraising.en'),
    fr: t(lang, 'forms.fundraising.fr'),
    es: t(lang, 'forms.fundraising.es'),
    he: t(lang, 'forms.fundraising.he'),
    y: t(lang, 'forms.fundraising.y'),
  };

  const errors: ErrorBag =
    useSelector((state:Store) => state.errors[form] || {} as ErrorBag);

  const getItems = () => {
    const items:SelectItem[] = [];
    const languageValues = values || FundraisingLanguagesList;
    languageValues.sort(
      (a, b) => a.localeCompare(b),
    ).map((item: any) => {
      items.push({
        id: item,
        text: languages[item],
      } as SelectItem);
      return items;
    });
    return items;
  };

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      error={!!errors[name]}
      key={`form-control-${name}`}>
      <FormSingleSelect
        style={styles}
        disabled={disabled}
        form={form}
        items={getItems()}
        label={label || 'Language'}
        name={name}
        onChange={onChange}
        value={value || ''}
        margin="dense"
        noMarginTop />
    </FormControl>
  );
};

export default FundraisingLanguageSelector;
